import { render, staticRenderFns } from "./pagination-secondary.vue?vue&type=template&id=3f6badfe&scoped=true"
import script from "./pagination-secondary.vue?vue&type=script&lang=js"
export * from "./pagination-secondary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6badfe",
  null
  
)

export default component.exports